export default __webpack_public_path__ + "static/media/nav-analysis.feb5ac86.svg";